import { render, staticRenderFns } from "./TipoAportacion.vue?vue&type=template&id=5fd35cb9&"
import script from "./TipoAportacion.vue?vue&type=script&lang=js&"
export * from "./TipoAportacion.vue?vue&type=script&lang=js&"
import style0 from "./TipoAportacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports